const Condition = require('./Condition');
const DamageEvent = require('../events/DamageEvent');
const { logError } = require('../logger');

const BleedingCondition = function (instigator, owner, battleState, potency) {
  const condition = new Condition(instigator, owner, battleState, potency);
  condition.handle = 'bleeding';
  condition.ConditionClass = BleedingCondition;

  condition.applyBleed = function () {
    try {
      if (owner.dead || !battleState || !battleState.allUnits) {
        this.expire();
        return;
      }

      if (battleState.paused) {
        return;
      }

      // apply bleed damage
      const damageEvent = new DamageEvent(battleState, this.instigator, this.potency, this);
      damageEvent.execute(battleState.allUnits[this.ownerId], false);

      // decrement potency
      --this.potency;
      if (this.potency <= 5) {
        this.expire();
      }
    } catch (err) {
      logError(err, {
        module: 'BleedingCondition',
        func: 'applyBleed',
        instigator,
        owner,
        battleState,
        potency,
      });
    }
  };

  condition.initInterval(condition.applyBleed, 3000);
  if (battleState.paused) {
    condition.intervalTimer.pause();
  }

  return condition;
};

BleedingCondition.fromCopy = function(cState, owner, instigator, battleState) {
  return BleedingCondition(instigator, owner, battleState, cState.potency);
};

module.exports = BleedingCondition;
